import React, {MouseEvent} from 'react'
import {NavLink, useLocation} from 'react-router-dom'
import styled from 'styled-components'

interface NavMenuItemProps {
  text: string
  link: string
  active: boolean
  id: string
  handleSetActive: (e: MouseEvent<HTMLElement>) => void
  hasSubMenu?: boolean
  firstSubMenuLink?: string
  subMenuLinks?: string[]
}

interface StyleProps {
  $active: boolean
  id: string
}

const StyledNavLink = styled(NavLink)<StyleProps>`
  padding-left: var(--space-4);
  padding-right: var(--space-4);
  height: 28px;
  display: flex;
  align-items: center;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => (props.$active ? 'var(--brand-cta)' : '#334D6E')};
  text-decoration: none;
  &:hover {
    color: var(--brand-cta);
    background-color: rgba(0, 0, 0, 0.04);
  }
`

const NavMenuItem = ({
  link,
  text,
  active,
  handleSetActive,
  id,
  hasSubMenu,
  firstSubMenuLink,
  subMenuLinks = [],
}: NavMenuItemProps) => {
  const location = useLocation()

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    handleSetActive(event)
  }

  // Determine the target link
  let targetLink = link

  // If this item has a submenu and firstSubMenuLink
  if (hasSubMenu && firstSubMenuLink) {
    // Check if user is already on one of the sub-menu pages
    const isOnSubMenuPage = subMenuLinks.some((subLink) => location.pathname.startsWith(subLink))

    // Only redirect to first sub-item if NOT already on a sub-menu page
    if (!isOnSubMenuPage) {
      targetLink = firstSubMenuLink
    } else {
      // Stay on current page
      targetLink = location.pathname
    }
  }

  return (
    <StyledNavLink
      style={{}}
      onClick={handleClick}
      id={id}
      to={targetLink}
      $active={active}
      data-testid={`nav-menu-item-${id}`}>
      {text}
    </StyledNavLink>
  )
}

export default NavMenuItem
